import {
  downloadTemplateDOCX,
  downloadTemplatePDF,
  generateTemplateHTML,
} from './htmlResumeTemplates';

export async function generateATSOptimizedDOCX(resumeData: any): Promise<void> {
  return downloadTemplateDOCX('ats-optimized', resumeData);
}

export async function generateATSOptimizedPDF(resumeData: any): Promise<void> {
  return downloadTemplatePDF('ats-optimized', resumeData);
}

export async function generateATSOptimizedHTML(resumeData: any): Promise<string> {
  return generateTemplateHTML('ats-optimized', resumeData);
}
